// Styles
import styles from './ReviewsIsEmpty.module.scss';

interface ReviewsIsEmptyProps {
    title: string;
    text: string;
    imageSrc?: string;
    alt?: string;
}

const ReviewsIsEmpty = ({
    title,
    text,
    imageSrc = '/images/memberships/clients-notfound.svg',
    alt = 'No reviews'
}: ReviewsIsEmptyProps) => {
    return (
        <div
            className={styles.containerEmpty}
            data-testid="reviews-empty"
        >
            <img
                className={styles.imageEmpty}
                src={imageSrc}
                alt={alt}
            />
            <h2 className={styles.titleEmpty}>{title}</h2>
            <div className={styles.descriptionEmptyContainer}>
                <p className={styles.descriptionEmpty}>{text}</p>
            </div>
        </div>
    );
};

export default ReviewsIsEmpty;
